export default __webpack_public_path__ + "static/media/Discover-Color.d88ad2f2.svg";